import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import Sidebar from 'project/containers/wrapup/sidebar';
import ProgressBar from 'project/components/wrapup/progress_bar';
import Tour from 'project/containers/wrapup/tour';
import { isCollaborator, getHideTour, setHideTour } from 'project/ducks/wrapup';
import { ALL_STEPS } from 'project/components/wrapup/all_steps';
import Meta from 'project/containers/meta';

/**
 * Single wrapup component.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Wrapup extends Component {
  constructor(props) {
    super(props)

    this.state = { step: null };
    this.selectStep = this.selectStep.bind(this);
    this.hideTour = this.hideTour.bind(this);
    this.getSteps = this.getSteps.bind(this);
  }

  componentDidMount() {
    const curAwardId = idx(this.props, _ => _.wrapup.award.id);
    if (curAwardId) {
      this.goToCurrentStep();
    }
  }

  componentDidUpdate(prevProps) {
    const prevAwardId = idx(prevProps, _ => _.wrapup.award.id);
    const prevStepIdx = idx(prevProps, _ => _.wrapup.stepIdx);
    const curAwardId = idx(this.props, _ => _.wrapup.award.id);
    const curStepIdx = idx(this.props, _ => _.wrapup.stepIdx);

    if (prevAwardId != curAwardId || prevStepIdx != curStepIdx) {
      this.goToCurrentStep();
    }
  }

  goToCurrentStep() {
    /* go to current wrapup step */
    const { wrapup } = this.props;
    if (wrapup) {
      this.selectStep(wrapup.steps[wrapup.stepIdx]);
    }
  }

  selectStep(step) {
    this.setState({ step });
  }

  hideTour() {
    setHideTour(this.props.wrapup);
    /* after setting the cookie to hide the tour, force re-render so view is updated */
    this.forceUpdate();
  }

  getSteps({ isCreative, isCollab }) {
    /* determine wrapup steps based on current context */
    const steps = [];
    const { wrapup } = this.props;

    ALL_STEPS.forEach((step) => {
      if (wrapup.steps.includes(step.name)) {
        steps.push({
          ...step,
          active: step.name == this.state.step,
          title: step.title[isCreative? 'creative' : 'client']
        })
      }
    });

    /* update steps with progress information */
    steps.forEach((step, i) => {
      step.available = i === wrapup.stepIdx;
      step.completed = i < wrapup.stepIdx;
    });

    /* collaborators are not supposed to have the last (survey) step */
    return isCollab? steps.slice(0, -1) : steps;
  }

  render() {
    const { user, wrapup } = this.props;
    const { step } = this.state;

    if (!wrapup) {
      return null;
    }

    const isCreative = user.id == wrapup.creative.id;
    const isCollab = isCollaborator(wrapup, user);
    const isAdmin = user.is_staff;
    const steps = this.getSteps({ isCreative, isCollab });
    const stepDefinition = steps.find(s => s.name == step);

    if (!stepDefinition) {
      return null;
    }

    const Step = stepDefinition.component;

    /* show tour slides if that's the case */
    if (!isAdmin && wrapup.stepIdx === 0 && !getHideTour(wrapup)) {
      return (
        <div className="wrapup">
          <Meta title="Wrap-up" />
          <Tour onDone={this.hideTour} />
        </div>
      );
    }

    return (
      <div className="wrapup">
        { !isAdmin && <Meta title="Wrap-up" /> }
        <ProgressBar isCreative={isCreative} wrapup={wrapup} steps={steps}
          onStepClick={this.selectStep} />
        <div className="row">
          <div className="small-16 medium-12 columns">
            <Step key={wrapup.award.id} wrapup={wrapup} details={stepDefinition}
              isCreative={isCreative} isAdmin={isAdmin} />
          </div>
          <div className="small-16 medium-4 columns">
            <Sidebar wrapup={wrapup}/>
          </div>
        </div>
      </div>
    );
  }
}

Wrapup.propTypes = {
  wrapup: PropTypes.object,
};



// WEBPACK FOOTER //
// ./project/components/wrapup/index.jsx